import { ApiHandler, createHandlerChainRunner } from "@insite/client-framework/HandlerCreator";
import { GetPunchoutUserIdentityApiParameter, getUserIdentity } from "@TKCCP/Services/PunchoutIdentityService";
import { PunchoutUserIdentityCollectionModel } from "@TKCCP/Types/ApiModels";

type HandlerType = ApiHandler<GetPunchoutUserIdentityApiParameter, PunchoutUserIdentityCollectionModel>;

export const PopulateApiParameter: HandlerType = props => {
    props.apiParameter = { ...props.parameter };
};

export const DispatchBeginLoadPunchoutUserIdentityList: HandlerType = props => {
    props.dispatch({
        type: "Data/PunchoutUserIdentity/BeginLoadIdentities" as any,
        parameter: props.parameter,
    });
};

export const RequestDataFromApi: HandlerType = async props => {
    props.apiResult = await getUserIdentity(props.apiParameter);
};
export const DispatchCompleteLoadPunchoutUserIdentityList: HandlerType = props => {
    props.dispatch({
        type: "Data/PunchoutUserIdentity/CompleteLoadIdentities" as any,
        collection: props.apiResult,
        parameter: props.parameter,
    });
};

export const chain = [
    PopulateApiParameter,
    DispatchBeginLoadPunchoutUserIdentityList,
    RequestDataFromApi,
    DispatchCompleteLoadPunchoutUserIdentityList,
];

const loadPunchoutUserIdentityList = createHandlerChainRunner(chain, "loadPunchoutUserIdentityList");
export default loadPunchoutUserIdentityList;
